import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ForgotPasswordLink } from '@layout/LoginPage';
import { ErrorMessage, TextField, Button } from '@atoms';
import { UtilityPageTemplate } from '@templates';
import messages from './messages';

export class LoginPage extends PureComponent {
  static propTypes = {
    login: PropTypes.func.isRequired,
    successfulLogin: PropTypes.bool,
    loginLoading: PropTypes.bool.isRequired,
  };

  state = {
    email: '',
    password: '',
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.props.login(this.state.email, this.state.password);
  };

  render() {
    return (
      <UtilityPageTemplate title="Log in to your account">
        {this.props.successfulLogin === false && (
          <ErrorMessage>
            {' '}
            <span> Incorrect email or password </span>{' '}
          </ErrorMessage>
        )}
        <form onSubmit={this.handleSubmit}>
          <TextField
            id="email"
            title="Email"
            type="email"
            required
            onChange={(event, email) => this.setState({ email })}
            floatingLabelText="Email"
          />
          <TextField
            id="password"
            title="Password"
            type="password"
            required
            onChange={(event, password) => this.setState({ password })}
            floatingLabelText="Password"
          />
          <Button
            primary
            type="submit"
            id="login"
            fullWidth
            loading={this.props.loginLoading}
          >
            <FormattedMessage {...messages.login} />
          </Button>
        </form>
        <ForgotPasswordLink>
          <FormattedMessage {...messages.forgotPassword} />{' '}
          <a onClick={this.props.forgotPasswordOnClick}>
            <FormattedMessage {...messages.click} />
          </a>
        </ForgotPasswordLink>
      </UtilityPageTemplate>
    );
  }
}



// WEBPACK FOOTER //
// ./components/pages/LoginPage/LoginPage.js